// navConfig.js
import {
  LayoutGrid,
  Settings,
  Building2,
  Upload,
  ShieldAlert,
  Briefcase,
  FileText,
  DollarSign,
  BarChart,
  Building,
  Calendar,
  AlertTriangle,
  FileSpreadsheet,
  FlaskRoundIcon,
  ShieldCheck,
  ChartPieIcon,
  Handshake,
  ChartNetwork,
  Home,
  Users,
} from "lucide-react";

export const navigationGroups = (
  isUserAdmin: boolean,
  isSidebarCollapsed: boolean = false,
  isFundSelected: boolean = true,
  isReportingPeriodSelected: boolean = false,
  collapsedGroups: Record<string, boolean> = {}
) => [
  {
    label: "Overview",
    icon: LayoutGrid,
    collapsed: collapsedGroups["Dashboard"] || false,
    items: [
      {
        path: "/app/dashboard",
        icon: LayoutGrid,
        label: "Getting started",
        context: "client",
      },
      {
        icon: Home,
        label: "S + Home",
        disabled: true,
      }
    ],
  },
   {
    label: "Fund",
    icon: Briefcase,
    collapsed: collapsedGroups["Fund"] || false,
    disabled: false,
    disabledMessage: "Please select a fund to access this section",
    items: [
    ],
  },
  {
    label: "Fund Operations",
    icon: Briefcase,
    collapsed: collapsedGroups["Fund Operations"] || false,
    disabled: !isFundSelected,
    disabledMessage: "Please select a fund to access this section",
    items: [
      {
        icon: FlaskRoundIcon,
        label: "Dashboard",
        disabled: !isFundSelected,
        path: "/app/fund-dashboard",
        context: "fund",
      },
      {
        icon: DollarSign,
        label: "Transactions",
        disabled: !isFundSelected,
        path: "/app/transactions",
        context: "fund",
      },
      {
        icon: FileText,
        label: "Holdings",
        disabled: !isFundSelected,
        path: "/app/holdings",
        context: "fund",
      },
      {
        icon: Calendar,
        label: "Reporting Periods",
        disabled: !isFundSelected,
        path: "/app/reporting-periods",
        context: "fund",
      }
    ],
  },
  {
    label: "Exceptions Management",
    icon: Building,
    collapsed: collapsedGroups["Exceptions Management"] || false,
    items: [
      {
        icon: AlertTriangle,
        label: "Exceptions",
        path: "/app/exceptions",
        context: "fund",
        disabled: !isFundSelected,
      },
      {
        icon: BarChart,
        label: "Holdings Comparison",
        path: "/app/holdings/comparison",
        context: "fund",
        disabled: !isFundSelected,
      },
      {
        icon: FileText,
        label: "Transaction Explainer",
        path: "/app/explainer",
        context: "fund",
        disabled: !isFundSelected,
      },
      {
        icon: ShieldCheck,
        label: "Validation Rules",
        path: "/app/fund-validation-rules",
        context: "fund",
        disabled: !isFundSelected,
      },
    ]
  },
    {
    label: "Reporting",
    icon: FileSpreadsheet,
    collapsed: collapsedGroups["Reporting"] || false,
    items: [
      {
        icon: FileSpreadsheet,
        label: "Reports",
        path: "/app/reports",
        context: "fund",
        disabled: !isFundSelected,
      },
      {
        icon: ChartPieIcon,
        label: "Analytics (new)",
        disabled: true,
      },
      {
        icon: ChartNetwork,
        label: "Lookthrough (new)",
        disabled: true,
      },
      {
        icon: Handshake,
        label: "Portal (new)",
        disabled: true,
      }
    ],
  },
  {
    label: "Data Management",
    icon: Upload,
    collapsed: collapsedGroups["Data Management"] || false,
    items: [
      {
        path: "/app/imports",
        icon: Upload,
        label: "Import Center",
        context: "client",
      },
       {
        path: "/app/fund-calendars",
        icon: Calendar,
        label: "Fund Calendars",
        disabled: false,
        context: "client",
      },
      {
        path: "/app/chart-of-accounts",
        icon: FileText,
        label: "Chart of Accounts",
        disabled: false,
        context: "client",
      },
      {
        path: "/app/funds",
        icon: Briefcase,
        label: "Funds",
        disabled: false,
        context: "client",
      },
      {
        path: "/app/investors",
        icon: Users,
        label: "Investors",
        disabled: false,
        context: "client",
      },
      {
        path: "/app/instruments",
        icon: DollarSign,
        label: "Instruments",
        disabled: false,
        context: "client",
      }
    ],
  },
  {
    label: "Administration",
    icon: Settings,
    collapsed: collapsedGroups["Administration"] || false,
    items: [
      {
        path: "/app/clients",
        icon: Building2,
        label: "Company Profile",
        context: "configuration",
      },
      {
        path: "/app/settings",
        icon: Settings,
        label: "Settings",
        context: "configuration",
      },
      ...(isUserAdmin
        ? [
            {
              path: "/app/admin",
              icon: ShieldAlert,
              label: "Admin",
              context: "configuration",
            },
          ]
        : []),
    ],
  },
];
